import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  Renderer2,
  OnDestroy
} from '@angular/core';

@Directive({
  selector: '[delayedClass]',
})
export class DelayedClassDirective implements AfterViewInit, OnDestroy {
  @Input() delayedClass = false;
  @Input() delayedClassName = 'animate';

  private timer?: number;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    if (!this.delayedClass) {
      return;
    }

    this.timer = window.setTimeout(() => {
      this.renderer.addClass(
        this.el.nativeElement,
        this.delayedClassName
      );
    }, 200);
  }

  ngOnDestroy(): void {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}